import { Text } from '@ksyos/design-system';

interface EyeSideType {
    side: 'OD' | 'OS';
}

export function TooV1ProcedureAddEditOdOsLabel({ side }: EyeSideType) {
    return (
        <Text
            fontWeight="bold"
            size="xs"
        >
            {side}
        </Text>
    );
}
